module.exports = __webpack_public_path__ + "assets/pdf/cycle4-plan-national.4dd9ce5b.pdf";